import Layout from '@/pages/Layout';

export default [
    {
        path: '/business',
        redirect: 'noredirect',
        component: Layout,
        name: 'business',
		hidenMenuWaterfall:true,
        meta: {
            title: '应用中心',
            icon: 'el-icon-cpu'
        },
        children: [
            {
                path: 'businessCenter',
                component: () => import('@/pages/business/BusinessCenter'),
                name: 'businessCenter',
                id: 'business/businessCenter',
                meta: {
                    title: '应用中心',
                    icon: 'desktop'
                },
                isShow: false,
                isNewMenu: true,
                isMenuWaterfall:false
            },
            {
                path: 'business-center/:appId/:modelId',
                component: () => import('@/pages/business/BusinessApplication'),
                name: 'business-center/:appId/:modelId',
                id: 'business/business-center/:appId/:modelId',
                meta: {
                    title: '业务应用',
                    icon: 'iconfont icon-other-yingyongzhongxin bc-custom-menu'
                },
                isMenuWaterfall:true,
                isNewMenu: false,
                children: [
                    {
                        path: 'business-center/:appId/:modelId',
                        component: () => import('@/pages/business/BusinessApplication'),
                        name: 'business-center/:appId/:modelId',
                        id: 'business/business-center/:appId/:modelId',
                        meta: {
                            title: '业务应用',
                            icon: 'table'
                        },
                        isMenuWaterfall:true
                    }
                ]
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-business.js